import { Modal } from "react-bootstrap";
import PerfectScrollbar from 'react-perfect-scrollbar';

const JsonSchemaBasedErrorPopup = props => {

    return (
        <Modal show onHide={() => props.closePopup()}>
            <Modal.Header closeButton>
                <h5>Failed to add {props?.name}</h5>
            </Modal.Header>
            <Modal.Body>
                <div className='my-3'>
                    <PerfectScrollbar className="category-json-error-popup">
                        {
                            props?.jsonErrors.map(error => 
                                <div style={{ fontSize: "15px" }} className='my-2'>
                                    {error}
                                </div>
                            )
                        }
                    </PerfectScrollbar>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default JsonSchemaBasedErrorPopup;